const state = {
  topHatData: {},
};

export default state;
